/* eslint-disable @typescript-eslint/naming-convention */

const oauth = {
  Email: "Email",
  Password: "Password",
  SignIn: "Sign In",
  authorizeApplication: "Authorize Application",
  unauthorized: "You are unauthorized to perform this action",
  unauthorized_must_be_practitioner:
    "You are unauthorized to perform this action. Please sign in with a valid practitioner account.",

  signIntoFullscript: "Sign into Fullscript",
  signInBlurb:
    "Access Fullscript's world class, professional grade supplement catalog directly in your EHR",
  signingUpBlurb: "By signing up, you agree to our ",
  termsOfService: "Terms of Service",

  dontHaveAnAccount: "Don't have a practitioner account? <1>Create one</1>",
  forgotPassword: "Forgot password?",
  finishLater: "Finish Later",
  complete: "Complete",
  goBackToMargin: "Go back to margin selection",

  // Margin Percentage
  marginPercentage: "Margin percentage",
  selectThePercentage: "Select the percentage",
  selectThePercentageTo: "Select the percentage to see patient savings",
  selectWhatPercentage:
    "Select what percentage of purchases you would like to make. The smaller your margin the more your patients will save.",
  yourPatientSavings: "Your patient savings is",
  // Banking Information
  congratulationsOnBecomingAProfit:
    "Congratulations on becoming a profit account. Please provide the following information to complete set up.",

  // Financial Address
  financialAddress: "Financial address",
  businessInfo: "Business information",
  payoutBankInfo: "Payout bank information",

  // New landing page
  AreYouNew: "Are you new to Fullscript?",
  PickOneOf:
    "Pick one of the options below so we can send you through the correct connection process",
  IAlready: "I already have an account",
  ContinueToSignIn: "Continue to sign in and your account will be connected",
  SignUp: "Sign Up",
  IAmNewTo: "I am new to Fullscript",
  ContinueToSignUp: "Continue to sign up for Fullscript <1>Free</1> Services",
  ContinueButton: "Continue",

  // Account type select
  title: "Select the account type you wish to setup.",
  learnMore: "Learn more about profit margin.",
  learnMoreLink:
    "https://support.fullscript.com/hc/en-us/articles/360022163832-Profit-dispensaries",
  noMarginTitle: "No margin account",
  noMarginDescription1: "Patients receive a 10% discount off MSRP",
  noMarginDescription2:
    "Fullscript remains the seller of record, and you will avoid tax implications",
  noMarginDescription3: "You can switch to a margin account at any time",
  marginTitle: "Margin account",
  marginDescription1:
    "Earn up to {{maxValue}}% of MSRP with Fullscript by selecting a margin account",
  marginDescription2: "Fullscript handles the sales tax, but there may be income tax implications",
  marginDescription3: "This account type can <1>not</1> be changed to a non margin later",
  nextButton: "Next",

  // Create User
  createAccount: "Create account",
  createFullscriptAccount: "Create Fullscript account",
  wereExcited:
    "We're excited to get you started. Create your account in just 2 minutes. Already have an account? Sign in",
  firstName: "First name",
  lastName: "Last name",
  pracType: "Practitioner Type",
  email: "Email",
  password: "Password",

  // student fields

  fieldOfStudy: "Field of study",
  graduationDate: "Graduation date",
  select: "Select",
  graduationDateInfo: "Graduation date must be a future date in the following format: YYYY‑MM‑DD.",
  proofOfEnrollment: "proof of enrollment",
  certification: "certification",

  // Credential/Certification upload
  credentials: {
    title: "Verify your credentials",
    description: "All healthcare providers must meet Fullscript's professional standards.",
  },
  skipForNow: "Skip for now",
  youCanSkipStep:
    "You can skip this step for now and have limited use of the platform, but credentials are required before patients can purchase recommendations.",
  gotIt: "Got it",
  cancel: "Cancel",
  or: "or",

  // Authorization View
  authorization: {
    title: "Confirm Fullscript integration",
    description: "Before we integrate, we need your permission to use the following information.",
  },
  Authorization: "Authorization",
  authorizationBlurb:
    "This integration requires access to your Fullscript account to perform the following:",
  readMore: "Read more...",
  showLess: "Show less...",

  // Form validation
  firstNameRequired: "First name is required",
  lastNameRequired: "Last name is required",
  practitionerRequired: "Please select a practitioner type",
  emailRequired: "Email is required",
  passwordRequired: "Your password needs to be at least 8 characters long",

  // Google SSO Errors
  userNotFound: "User not found, try another email or create an account",

  WelcomeToFullscript: "Welcome to Fullscript",
  InformationToGetStarted: "We just need a bit of information to get you started.",
  Verify: "Verify",
  Profit: "Profit margin",
  BankInfo: "Bank info (optional)",
  AddYourCredential:
    "Add your {{ credentialTerm }} to make sure to get all the benefits out of having Fullscript.",
  PostalCode: "Postal code",
  ZipCode: "ZIP code",
  State: "State",
  Province: "Province",
  PhoneNumber: "Phone number",
  PhoneTooltip:
    "We're here to help. Providing this information helps our team give our users a <2>faster</2> support experience",
  Select: "Select",
  FinishTheRestLater: "Finish the rest later",
  Next: "Next",

  SignInComplete: "Sign in is complete",
  AccountSetupComplete: "Account setup is complete",
  JustOneMoreStep: "Just one more step",
  BeforeWeIntegrate:
    "Before we integrate, we need your permission to use the following information.",
  IDontAgree: "I don't agree",
  IAgree: "I agree",
  ReadMore: "Read more",
  ReadLess: "Read less",
  AreYouSure: "Are you sure?",
  YourFullscriptAccountWill:
    "Your Fullscript account will remain active, but the DrChrono integration won't be available to you. Are you sure you want to continue without integrating?",
  NoGoBack: "No, go back",
  YesCancelIntegration: "Yes, cancel integration",

  // Cancel integration modal
  cancelIntegration: {
    title: "Leave Integration?",
    description:
      "Your Fullscript account will remain active, but the {{applicationName}} integration won't be available to you.",
    confirm: "Yes, leave integration",
  },
} as const;

export { oauth };
